import { __decorate } from "tslib";
import HelixElement from '../../shared/types/helix-element.js';
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { consume } from '@lit/context';
import { activeTabNameContext } from './tab-group-context.js';
import { nothing } from 'lit-html';
let HlxTabPanel = class HlxTabPanel extends HelixElement {
    render() {
        if (this.name !== this.activeTabName) {
            return nothing;
        }
        return html `
            <div role="tabpanel" tabindex="0">
                <slot></slot>
            </div>
        `;
    }
};
__decorate([
    property()
], HlxTabPanel.prototype, "name", void 0);
__decorate([
    consume({ context: activeTabNameContext, subscribe: true }),
    property({ attribute: false })
], HlxTabPanel.prototype, "activeTabName", void 0);
HlxTabPanel = __decorate([
    customElement('hlx-tab-panel')
], HlxTabPanel);
export { HlxTabPanel };
//# sourceMappingURL=tab-panel.js.map